<template>
  <div class="flex">
    <svg
      class="flex fill-current text-gray-500 inline-block h-4 w-4 cursor-pointer"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      @click="$emit('click')"
    >
      <path
        d="M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"
      />
    </svg>
  </div>
</template>

<script>
export default {}
</script>

<style></style>
